import { Component, input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'dbw-summary-card',
  styleUrl: './summary-card.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  template: `
    <article class="summary-card dbw-card dbw-card--xl">
      <span class="summary-card__label">{{ label() }}</span>
      <div class="summary-card__value-row">
        <strong
          class="summary-card__value"
          [class.summary-card__value--compact]="compactValue()"
        >
          <ng-content select="[summaryValue]"></ng-content>
        </strong>
        <ng-content select="[summaryAside]"></ng-content>
      </div>
      @if (meta()) {
        <span class="summary-card__meta">{{ meta() }}</span>
      }
    </article>
  `
})
export class SummaryCardComponent {
  readonly label = input.required<string>();
  readonly meta = input('');
  readonly compactValue = input(false);
}
